export const state = () => ({
  apiUrl: {
    // 공통설정 API URL
    commonSettUrl: '/api/url',
    // 금지네트워크 API
    denyNetRangeUrl: '/api/url'
  },
  // 공통설정 data
  commonSettResult: {
    // 신청기간 30-180일
    isApplicationPeriod: false,
    vApplicationPeriod: 180,
    // 출발지 10-60개
    isSource: false,
    vSource: 60,
    // 출발지 네트워크 mask 8-24
    isSourceNetMask: false,
    vSourceNetMask: 16,
    // 목적지 10-60
    isTarget: false,
    vTarget: 60,
    isTargetNetMask: false,
    vTargetNetMask: 16,
    // 서비스 10-60개
    isService: false,
    vService: 60
  },
  denyNetRange: {
    // 금지 네트워크 내역
    isDenyNetRange: false,
    // 금지네트워크 대역
    denyNetData: []
  },
  errorMessage: null
})

export const mutations = {
  // 공통설정
  mutCommonSett () {
  },
  // 금지 네트워크 대역
  mutDenyNetRange () {
  },
  // 금지 네트워크 대역 추가d
  mutPostDenyNetRange (state, payload) {
    const denyNetSourceIp = payload.deny_net_source_ip.map(item => {
      return item.expIp
    }).join('<Br/>')

    const denyNetDestIp = payload.deny_net_dest_ip.map(item => {
      return item.expIp
    }).join('<br/>')
    const denyNetService = []

    const obj = {
      deny_net_title: payload.deny_net_title,
      deny_net_source_ip: denyNetSourceIp,
      deny_net_dest_ip: denyNetDestIp,
      deny_net_services: denyNetService,
      deny_net_way: payload.deny_net_way,
      deny_net_desc: payload.deny_net_desc
    }
    // state.denyNetRange.denyNetData.push(obj)
    state.denyNetRange.denyNetData.push(obj)
  },
  mutErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  // 공통설정 정보 가져오기
  acsCommonSett ({commit}) {
    commit('mutCommonSett', {})
  },
  // 금지 네트워크 대역
  acsDenyNetRange ({commit}) {
    commit('mutDenyNetRange', {})
  },
  // 금지 네트워크 대역 추가
  acsPostDenyNetRange ({commit, state}, payload) {
    commit('mutPostDenyNetRange', payload)
  },
  acsSetErrorMessage ({commit, state}, payload) {
    const result = {}
    result.error = payload
    commit('mutErrorMessage', result)
  }
}
export const getters = {}
export const strict = false
